if (!customElements.get('theme-gallery')) {
  class ThemeGallery extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.galleryVideoList = Array.from(this.querySelectorAll('.gallery--item .gallery--video'));

      this.hoverPlayList = this.galleryVideoList.filter((item) => {
        return item.classList.contains('hover-play') && item;
      });

      this.autoPlayList = this.galleryVideoList.filter((item) => {
        return !item.classList.contains('hover-play') && item;
      });

      this.autoPlayList.forEach((item, i) => {
        item.querySelector('video').play();
      });

      this.setHoverPlayList();
      this.setAnimations();

      if (Shopify.designMode) {
        this.addEventListener('shopify:section:load', (event) => {
          this.setAnimations();

          setTimeout(() => {
            ScrollTrigger.refresh();
          }, 100);
        });
      }

      this.setInitialScrollPosition(); // İlk pozisyonu ayarla
      this.initCenterEffect(); // Ortadaki görsel büyütme işlevini başlat
    }

    setHoverPlayList() {
      this.hoverPlayList.forEach((item, i) => {
        item.querySelector('video').currentTime = 0.1;
        item.parentElement.addEventListener('mouseenter', () => this.playVideo(item));
        item.parentElement.addEventListener('mouseleave', () => this.pauseVideo(item));
      });
    }

    playVideo(videoContainer) {
      videoContainer.querySelector('video').play();
    }

    pauseVideo(videoContainer) {
      videoContainer.querySelector('video').pause();
    }

    setAnimations() {
      ScrollTrigger.batch(this.querySelectorAll('figure'), {
        start: "top 90%",
        onEnter: (elements, triggers) => {
          gsap.to(elements, { opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
        },
      });
    }

    setInitialScrollPosition() {
      const galleryInner = this.querySelector('.gallery--inner');
      const items = Array.from(galleryInner.children);

      if (galleryInner && items.length > 0) {
        const totalItems = items.length;
        const middleIndex = Math.floor(totalItems / 2);
        const itemWidth = items[0].offsetWidth;

        galleryInner.scrollLeft = middleIndex * itemWidth;
      }
    }

    initCenterEffect() {
      const galleryInner = this.querySelector('.gallery--inner');
      const items = Array.from(galleryInner.children);

      const updateActiveItem = () => {
        const galleryRect = galleryInner.getBoundingClientRect();
        const centerX = galleryRect.left + galleryRect.width / 2;

        items.forEach((item) => {
          const itemRect = item.getBoundingClientRect();
          const itemCenterX = itemRect.left + itemRect.width / 2;

          if (Math.abs(centerX - itemCenterX) < itemRect.width / 2) {
            item.classList.add('active'); // Ortadaki görseli büyüt
          } else {
            item.classList.remove('active'); // Diğerlerini küçült
          }
        });
      };

      // Kaydırma olayını dinle
      galleryInner.addEventListener('scroll', () => {
        requestAnimationFrame(updateActiveItem);
      });

      // İlk yükleme sırasında merkezi ayarla
      updateActiveItem();
    }
  }

  customElements.define('theme-gallery', ThemeGallery);

  
}


// ===== Global a11y fix for Lighthouse: link name issues =====
(function () {
  function safeLabelFromHref(href) {
    try {
      const u = new URL(href, window.location.origin);
      const last = (u.pathname.split('/').filter(Boolean).pop() || 'Explore').replace(/[-_]+/g, ' ');
      return last.charAt(0).toUpperCase() + last.slice(1);
    } catch (e) {
      return 'Explore';
    }
  }

  function fixLinks() {

    document.querySelectorAll('a.gallery--item-content-link').forEach((a) => {
     
      a.setAttribute('aria-hidden', 'true');
      a.setAttribute('tabindex', '-1');
    });

   
    document.querySelectorAll('.scrolling-content--section-inner a.button').forEach((a) => {
      const txt = (a.textContent || '').trim();
      const aria = (a.getAttribute('aria-label') || '').trim();
      const title = (a.getAttribute('title') || '').trim();
      const hasName = txt.length > 0 || aria.length > 0 || title.length > 0;

      if (!hasName) {
        const label = safeLabelFromHref(a.getAttribute('href') || a.href || '');
        a.setAttribute('aria-label', label);
        a.setAttribute('title', label);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixLinks, { once: true });
  } else {
    fixLinks();
  }


  document.addEventListener('shopify:section:load', fixLinks);
})();


